import { render, staticRenderFns } from "./NotSafeForWork1.vue?vue&type=template&id=4e17df90&scoped=true&"
import script from "./NotSafeForWork1.vue?vue&type=script&lang=js&"
export * from "./NotSafeForWork1.vue?vue&type=script&lang=js&"
import style0 from "./NotSafeForWork1.vue?vue&type=style&index=0&id=4e17df90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e17df90",
  null
  
)

export default component.exports